import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import Select from "react-select";
import _ from "lodash";
import classNames from "classnames";
import "./index.css";
import IconStoreModal from "../Polls/components/IconStoreModal";
import { LayerTypes } from "../../Constants/brand";
import Firebase from "../../firebasehelper";
import Fade from "@material-ui/core/Fade";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../Constants/types";
import { UPLOADING_VIDEO, UPLOADING_IMAGE } from "../../Constants/string";
import ImageUpload from "../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../components/ContentUpload/YoutubeInput";
const icon_pending_img = require("../../assets/media/icons/pending.png");

const SurveyMakerForm = forwardRef(
  (
    { publishSurvey, onUpdateStatus, initial, uploadFolder, hex, white },
    ref
  ) => {
    const [survey, setSurvey] = useState({
      name: "",
      welcomeText: "",
      communicationLayers: [{ type: "", statement: "" }],
    });
    const [loadingState, setLoadingState] = useState({
      loading: false,
      loading_script: "",
    });
    const [mediaUrl, setMediaUrl] = useState("");
    const [modification, setModification] = useState({});

    useEffect(() => {
      if (initial) {
        setSurvey(initial);
      }
    }, [initial]);

    const handleInputChange = (event) => {
      const { name, value } = event.target;

      const newSurvey = _.cloneDeep(survey);
      newSurvey[name] = value;
      setSurvey(newSurvey);
      onUpdateStatus(newSurvey);
    };

    const handleLayerChange = (index, key, value) => {
      const newSurvey = _.cloneDeep(survey);
      newSurvey["communicationLayers"][index][key] = value;
      setSurvey(newSurvey);
      onUpdateStatus(newSurvey);
    };

    const handleAnswerChange = (index, answer_index, value) => {
      const newSurvey = _.cloneDeep(survey);
      newSurvey["communicationLayers"][index].answers[answer_index] = value;
      setSurvey(newSurvey);
      onUpdateStatus(newSurvey);
    };

    useImperativeHandle(ref, () => ({
      addNewCommunicationLayer() {
        const newSurvey = _.cloneDeep(survey);
        newSurvey["communicationLayers"].push({ type: "", statement: "" });
        setSurvey(newSurvey);
        onUpdateStatus(newSurvey);
      },
      handlePublishSurvey() {
        if (!survey.name || !survey.welcomeText) {
          alert("Please fill empty fields");
          return;
        }
        let flag = survey.communicationLayers.some((obj) => {
          if (obj.type === "Statement" || obj.type === "Question") {
            return !obj.type || !obj.statement;
          } else if (obj.type === "Polls") {
            if (!obj.answers) return true;
            let empties = obj.answers.filter((answer) => !answer);
            return empties.length || obj.answers.length < 2;
          } else if (!obj.type) return true;
        });
        if (flag) {
          alert("Please fill empty fields");
          return;
        }
        publishSurvey(survey);

        // Reset survey state
        const initSurvey = {
          name: "",
          welcomeText: "",
          communicationLayers: [{ type: "", statement: "" }],
        };
        setSurvey(initSurvey);
        onUpdateStatus(initSurvey);
      },
    }));

    const addAnswer = (index) => {
      let newSurvey = _.cloneDeep(survey);
      if (!newSurvey["communicationLayers"][index].answers)
        newSurvey["communicationLayers"][index].answers = [""];
      else newSurvey["communicationLayers"][index].answers.push("");
      setSurvey(newSurvey);
      onUpdateStatus(newSurvey);
    };
    const removeAnswer = (index, answer_index) => {
      let newSurvey = _.cloneDeep(survey);
      newSurvey["communicationLayers"][index].answers.splice(answer_index, 1);
      setSurvey(newSurvey);
      onUpdateStatus(newSurvey);
    };

    const handleSetMediaURL = (imgURL, index, key) => {
      setMediaUrl(imgURL);
      // modification tracking..
      let newModification = { ...modification, media_url: imgURL };
      setModification(newModification);

      const newSurvey = _.cloneDeep(survey);
      newSurvey["communicationLayers"][index]["media_url"] = imgURL;
      setSurvey(newSurvey);
      onUpdateStatus(newSurvey);
    };
    const handleUploadProgress = (snapshot) => {
      var progress = (
        (snapshot.bytesTransferred / snapshot.totalBytes) *
        100
      ).toFixed(0);
      const loading_script = UPLOADING_VIDEO + " " + progress + "%";
      setLoadingState({ loading: loadingState.loading, loading_script });
    };

    const handleUploadError = (error) => {
      setLoadingState({ loading: false, loading_script: "" });
    };

    const uploadContent = (contentType, index) => async (mediaContent) => {
      const title = new Date().getTime().toString();
      if (contentType === GIF_UPLOAD) {
        setLoadingState({ loading: true, loading_script: UPLOADING_IMAGE });
        let gif_url = await Firebase.uploadGif(
          mediaContent,
          title,
          uploadFolder + "/gifs"
        );
        setLoadingState({ loading: false, loading_script: "" });
        handleSetMediaURL(gif_url, index);
      } else if (contentType === IMAGE_UPLOAD) {
        setLoadingState({ loading: true, loading_script: UPLOADING_IMAGE });
        let img_url = await Firebase.uploadImage(
          mediaContent,
          title,
          uploadFolder + "/images"
        );
        setLoadingState({ loading: false, loading_script: "" });
        handleSetMediaURL(img_url, index);
      } else if (contentType === VIDEO_UPLOAD) {
        const uploadTask = Firebase.uploadVideo(
          mediaContent,
          uploadFolder + "/videos"
        );
        setLoadingState({ loading: true, loading_script: UPLOADING_VIDEO });
        uploadTask.on(
          "state_changed",
          handleUploadProgress,
          handleUploadError,
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              setLoadingState({ loading: false, loading_script: "" });
              handleSetMediaURL(downloadURL, index);
            });
          }
        );
      } else if (contentType === YOUTUBE_URL) {
        handleSetMediaURL(mediaContent, index);
      }
    };

    return (
      <div style={{ textAlign: "left", width: "100%" }}>
        <h4 className="section-title">Survey name</h4>
        <input
          name="name"
          className="form-control form-control-md form-control-alt"
          placeholder="Type name"
          value={survey ? survey.name : ""}
          onChange={handleInputChange}
        />
        {survey.name && (
          <React.Fragment>
            <h4 className="section-title">Survey welcome message</h4>
            <textarea
              name="welcomeText"
              className="form-control form-control-md form-control-alt"
              placeholder="Welcome message"
              value={survey.welcomeText}
              onChange={handleInputChange}
            />
          </React.Fragment>
        )}
        {survey.name && survey.welcomeText && (
          <React.Fragment>
            {survey.communicationLayers.map((layer, index) => (
              <React.Fragment>
                <div className="section-title">
                  <h4>Add Communication Layer</h4>
                  <p>{index + 1}</p>
                </div>
                <div className="input-container">
                  <Select
                    value={{
                      label: survey.communicationLayers[index].type,
                      value: survey.communicationLayers[index].type,
                    }}
                    onChange={(value) =>
                      handleLayerChange(index, "type", value.value)
                    }
                    options={LayerTypes}
                  />
                </div>
                {["Statement", "Question", "Statement agreeableness"].find(
                  (c) => c === survey.communicationLayers[index].type
                ) && (
                  <React.Fragment>
                    <div className="section-title">
                      <h4 className="section-title">
                        {survey.communicationLayers[index].type}
                      </h4>
                      <p>{index + 1}</p>
                    </div>
                    <input
                      name="statement"
                      className="form-control form-control-md form-control-alt mb-4"
                      value={survey.communicationLayers[index].statement}
                      onChange={({ target }) =>
                        handleLayerChange(index, "statement", target.value)
                      }
                      autoComplete="off"
                    />
                  </React.Fragment>
                )}
                {survey.communicationLayers[index].type === "Polls" && (
                  <React.Fragment>
                    <div className="section-title">
                      <h4 className="section-title">
                        {survey.communicationLayers[index].type}
                      </h4>
                      <p>{index + 1}</p>
                    </div>
                    <input
                      name="statement"
                      placeholder="Polls Question"
                      className="form-control form-control-md form-control-alt mb-2"
                      value={survey.communicationLayers[index].statement}
                      onChange={({ target }) =>
                        handleLayerChange(index, "statement", target.value)
                      }
                      autoComplete="off"
                    />
                    {survey.communicationLayers[index].answers &&
                      survey.communicationLayers[index].answers.map(
                        (answer, answer_index) => (
                          <div className="polls-answer">
                            <input
                              placeholder="Answer"
                              className="form-control form-control-md form-control-alt mt-2 mb-2"
                              value={
                                survey.communicationLayers[index].answers
                                  ? survey.communicationLayers[index].answers[
                                      answer_index
                                    ]
                                  : ""
                              }
                              onChange={({ target }) =>
                                handleAnswerChange(
                                  index,
                                  answer_index,
                                  target.value
                                )
                              }
                              autoComplete="off"
                            />
                            <button
                              onClick={() => removeAnswer(index, answer_index)}
                            >
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </div>
                        )
                      )}
                    <button
                      className="btn btn-white btn-brand-hex mb-3"
                      style={{
                        "--hover-text-color": "black",
                        "--hover-color": "white",
                        backgroundColor: hex,
                        color: white ? "white" : "black",
                      }}
                      type="button"
                      onClick={() => addAnswer(index)}
                    >
                      Add new answer
                    </button>
                  </React.Fragment>
                )}
                {["image_file", "gif_file", "video_file", "youtube_url"].find(
                  (c) => c === survey.communicationLayers[index].type
                ) && (
                  <div className="col-div mb-2" style={{ marginTop: "15px" }}>
                    {survey.communicationLayers[index].type === YOUTUBE_URL && (
                      <YoutubeInput
                        onChangeContent={uploadContent(YOUTUBE_URL, index)}
                        currentUrl={
                          survey.communicationLayers[index].media_url ||
                          mediaUrl ||
                          null
                        }
                      />
                    )}
                    {survey.communicationLayers[index].type ===
                      IMAGE_UPLOAD && (
                      <ImageUpload
                        onChangeContent={uploadContent(IMAGE_UPLOAD, index)}
                        contentUrl={
                          survey.communicationLayers[index].media_url ||
                          mediaUrl ||
                          null
                        }
                      />
                    )}
                    {survey.communicationLayers[index].type === GIF_UPLOAD && (
                      <ImageUpload
                        isGif={true}
                        onChangeContent={uploadContent(GIF_UPLOAD, index)}
                        contentUrl={
                          survey.communicationLayers[index].media_url ||
                          mediaUrl ||
                          null
                        }
                      />
                    )}
                    {survey.communicationLayers[index].type ===
                      VIDEO_UPLOAD && (
                      <VideoUpload
                        onChangeContent={uploadContent(VIDEO_UPLOAD, index)}
                        defaultVideo={
                          survey.communicationLayers[index].media_url ||
                          mediaUrl ||
                          null
                        }
                      />
                    )}
                  </div>
                )}
              </React.Fragment>
            ))}
            <Fade
              in={loadingState.loading}
              style={{
                transitionDelay: loadingState.loading ? "800ms" : "0ms",
              }}
              unmountOnExit
            >
              <React.Fragment>
                <p>{loadingState.loading_script}</p>
                <CircularProgress />
              </React.Fragment>
            </Fade>
          </React.Fragment>
        )}
        {/* <IconStoreModal selectImage={selectImage} /> */}
      </div>
    );
  }
);
export default SurveyMakerForm;



// WEBPACK FOOTER //
// ./src/screens/SurveyMaker/SurveyMakerForm.js